// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__32wSS","range":"MonthRangeSwitch_range__3mGoQ","disabled":"MonthRangeSwitch_disabled__8XvTV"};